import React from 'react';
import _ from 'lodash';
import { Link } from 'react-router-dom';
import { Translate } from 'core/translate';

const getTopSortedOptions = options => {
  const sorted = _.sortBy(options, 'id');
  return _.take(sorted, 4);
};

const PackageOptionsList = ({ id, options, analyticsKey, analyticsKey2 }) => {
  if (options.length === 0) {
    return null;
  }

  const sortedOptions = getTopSortedOptions(options);

  const listItems = sortedOptions.map(option => {
    return (
      <Link
        key={option.id}
        to={`/packages/package/${id}/item/${option.id}`}
        className="package-option-list__item stat-text-link"
        data-dtm={analyticsKey}
        data-dtm2={analyticsKey2}>
        <div
          dangerouslySetInnerHTML={{ __html: option.description }}
          className="package-option-list__description"
        />
        {option.smallImageUrl ? (
          <div className="package-option-list__item-image">
            <img src={option.smallImageUrl} alt="" />
          </div>
        ) : null}
      </Link>
    );
  });

  return (
    <div className="package-list-item__options">
      <div className="package-list-item__subheader">
        <Translate value="package.includes" />
      </div>
      <div>{listItems}</div>
    </div>
  );
};

export default PackageOptionsList;
